import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { LineChart, Line, XAxis, YAxis, Label, ResponsiveContainer } from 'recharts';
import Title from './Title';
import { ProcessusLog } from '../../../models/processusLog';
import { ChartObject } from '../../../models/chartObject';

export default function Chart(props: { logs: ProcessusLog[] | null }) {
	const [allLogs] = useState<ProcessusLog[] | null>(props.logs);
	const theme = useTheme();
	const [chartDatas, setChartDatas] = useState<ChartObject[]>([]);

	useEffect(() => {
		if (allLogs) {
			const logs: ProcessusLog[] = [...allLogs].reverse();

			for (let log of logs) {
				// Créer un object "Date" sinon on n'auras pas accès aux fonctions getMonth ect
				const dateLog: Date = new Date(log.date);

				const myDay: string = `${dateLog.getDate()}/${dateLog.getMonth() + 1}`;
				// Chercher si un log à déjà été effectué sur le même jour
				const data: ChartObject | undefined = chartDatas.find(({ day }) => day === myDay);

				if (data && log.errorStack !== '') data.number += 1;
				else if (log.errorStack !== '') chartDatas.push({ day: myDay, number: 1 });
				else if (log.errorStack === '' && !data) chartDatas.push({ day: myDay, number: 0 });
			}
			setChartDatas(chartDatas);
		}
	}, [allLogs, chartDatas]);

	return (
		<React.Fragment>
			<Title>Nombre d'erreurs sur les 7 derniers jours</Title>
			<ResponsiveContainer>
				<LineChart
					data={chartDatas}
					margin={{
						top: 16,
						right: 16,
						bottom: 0,
						left: 24,
					}}
				>
					<XAxis dataKey="day" stroke={theme.palette.text.secondary} style={theme.typography.body2} />
					<YAxis stroke={theme.palette.text.secondary} style={theme.typography.body2}>
						<Label
							angle={270}
							position="left"
							style={{
								textAnchor: 'middle',
								fill: theme.palette.text.primary,
								...theme.typography.body1,
							}}
						>
							Plantages
						</Label>
					</YAxis>
					<Line isAnimationActive={true} type="monotone" dataKey="number" stroke={theme.palette.primary.main} dot={false} />
				</LineChart>
			</ResponsiveContainer>
		</React.Fragment>
	);
}
